export default [
    {
        path: '/404-page-not-found',
        name: 'PageNotFound',
        component: () => import('@/views/errors/404'),
    },
    {
        path: '/403-forbidden',
        name: 'Forbidden',
        component: () => import('@/views/errors/403'),
    },
];



// WEBPACK FOOTER //
// ./src/views/errors/route.js